// extracted by mini-css-extract-plugin
export var back = "BetslipFooter-module--back--91cfd";
export var blue = "#0eb3f2";
export var button = "BetslipFooter-module--button--9ab7c";
export var buttons = "BetslipFooter-module--buttons--dfa01";
export var center = "BetslipFooter-module--center--2b45e";
export var clamp = "BetslipFooter-module--clamp--1a132";
export var close = "BetslipFooter-module--close--0c80d";
export var container = "BetslipFooter-module--container--2f508";
export var content = "BetslipFooter-module--content--774b7";
export var emphasis = "BetslipFooter-module--emphasis--53ef5";
export var eventName = "BetslipFooter-module--eventName--b192e";
export var exoticTitle = "BetslipFooter-module--exoticTitle--b6217";
export var footer = "BetslipFooter-module--footer--2b378";
export var footerInner = "BetslipFooter-module--footerInner--3d30e";
export var green = "#57d33b";
export var greenLink = "BetslipFooter-module--green-link--57eb6";
export var grey = "var(--tone-mid)";
export var header = "BetslipFooter-module--header--16343";
export var hidden = "BetslipFooter-module--hidden--d46df";
export var icon = "BetslipFooter-module--icon--60445";
export var iconButton = "BetslipFooter-module--iconButton--c3653";
export var info = "BetslipFooter-module--info--a897a";
export var isReviewing = "BetslipFooter-module--isReviewing--fd89b";
export var label = "BetslipFooter-module--label--99670";
export var largeFooter = "BetslipFooter-module--largeFooter--0ed60";
export var marketName = "BetslipFooter-module--marketName--81c57";
export var notchGap = "32px";
export var orange = "#f8662b";
export var outcomeIcon = "BetslipFooter-module--outcomeIcon--5a63e";
export var panel = "BetslipFooter-module--panel--d39a3";
export var red = "#ff2741";
export var right = "BetslipFooter-module--right--aca3e";
export var scrollArea = "BetslipFooter-module--scrollArea--101a4";
export var selectionName = "BetslipFooter-module--selectionName--8f707";
export var small = "BetslipFooter-module--small--21dce";
export var smallFooter = "BetslipFooter-module--smallFooter--fbc02";
export var tab = "BetslipFooter-module--tab--2c7b2";
export var tabList = "BetslipFooter-module--tabList--fa232";
export var tabListContainer = "BetslipFooter-module--tabListContainer--b85b5";
export var tabs = "BetslipFooter-module--tabs--d8be0";
export var title = "BetslipFooter-module--title--82321";
export var trash = "BetslipFooter-module--trash--0613a";
export var value = "BetslipFooter-module--value--b35f6";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";